import { Button } from '@src/design-system/button';
import { Edit2, Eye } from 'iconsax-react';
import { Link } from 'react-router-dom';
import { createRoute } from '@src/core/router/paths';
import { SingleDeleteAction } from '@src/design-system/molecules/ticlick-table/actions';
import { CreateLeadModal as CreateAndEditLeadModal } from '../dialogs/create-lead-modal';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from '@src/design-system/dialog';
import { entities } from '@shared/constants/entities';
import { HasPermission } from '@features/roles/guards/has-permission';
import type { TLead } from '@shared/types/lead';
import leadApi from '@features/leads/services/lead-api';

interface RowActionsCellProps {
  lead: TLead;
  isLeadNote?: boolean;
}

const RowActionsCell = ({ lead, isLeadNote }: RowActionsCellProps) => {
  const { mutateAsync: deleteLead, isPending } = leadApi.useDelete();

  return (
    <div className='flex items-center justify-center'>
      <HasPermission
        entity={entities.lead}
        action='view'
      >
        <Button
          variant='ghost'
          size={'iconSm'}
        >
          <Link to={createRoute(`/leads/${lead.id}`)}>
            <Eye
              size='20'
              cursor='pointer'
              variant='TwoTone'
              color='var(--color-gray-800)'
            />
          </Link>
        </Button>
      </HasPermission>

      {!isLeadNote && (
        <HasPermission
          entity={entities.lead}
          action='change'
        >
          <Button
            variant='ghost'
            size={'iconSm'}
            className='pt-0.5'
          >
            <Dialog>
              <DialogTrigger className='cursor-pointer'>
                <Edit2
                  size='16'
                  className='text-gray-800'
                  variant='TwoTone'
                />
              </DialogTrigger>
              <DialogContent>
                <CreateAndEditLeadModal lead={lead} />
              </DialogContent>
            </Dialog>
          </Button>
        </HasPermission>
      )}

      <HasPermission
        entity={entities.lead}
        action='delete'
      >
        <SingleDeleteAction
          id={lead.id}
          label='lead'
          isLoading={isPending}
          onConfirm={(closeModal) =>
            deleteLead({ id: lead.id }, { onSuccess: closeModal })
          }
        />
      </HasPermission>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default RowActionsCell;
